// extracted by mini-css-extract-plugin
export default {"zoomInput":"bLwcb uV_O0","button":"yHiGO"};